/*** IMPORTS FROM imports-loader ***/
var fetchPolyfill = require("polyfills/fetch");
var classListPolyfill = require("polyfills/classList");

import _ from "underscore";

const HAS_REW_RELIC = window.NREUM && _.isFunction(window.NREUM.noticeError);

let lastException;

/**
 * Handle an error by sending data to New Relic (if available).
 * @param {Error|String} err
 */
function handleError(err) {
    // checking for duplicate exceptions so we don't spam New Relic
    if (err === lastException) {
        return;
    }

    lastException = err;

    if (err instanceof Response) {
        try {
            throw new Error(
                `Request for ${err.url} responded with ${err.status} ${err.statusText}`
            );
        } catch (e) {
            err = e;
        }
    } else if (!(err instanceof Error)) {
        let message;
        try {
            message = JSON.stringify(err);
        } catch (e) {
            message = err + "";
        }
        try {
            throw new Error(message);
        } catch (e) {
            err = e;
        }
    }

    console.error(err);

    if (HAS_REW_RELIC) {
        window.NREUM.noticeError(err);
    }
}

/**
 * Wraps a single function.
 * @param {Function} fn
 * @returns {Function}
 */
function wrap(fn) {
    if (fn.__wrapped__) {
        return fn;
    }

    function wrapped() {
        try {
            return fn.apply(this, arguments);
        } catch (e) {
            handleError(e);
            throw e;
        }
    }

    _.extend(wrapped, fn);
    _.extend(wrapped.prototype, fn.prototype);

    wrapped.__wrapped__ = true;
    return wrapped;
}

/**
 * Wraps a constructor function plus all methods on the prototype.
 * @param {Function} fn
 * @returns {Function}
 */
function wrapClass(fn) {
    // wrap constructor
    fn = wrap(fn);

    // wrap prototype methods
    _.each(_.functions(fn.prototype), function(name) {
        fn.prototype[name] = wrap(fn.prototype[name]);
    });

    return fn;
}

// public API
export default {
    wrap: wrap,
    wrapClass: wrapClass,
    error: handleError
};

